import { type SettingDefinitionMetadata, type SettingsRegistryMetadata } from '@aysar/contracts';

/**
 * One definition out of the registry, by key.
 *
 * The registry is delivered as groups of subgroups of settings (W8) and this
 * module reads three keys out of it from two hooks, so the walk is written
 * **once**: two copies would be two chances to answer `undefined` where the
 * other answers `null`, and the difference decides whether a surface renders an
 * error or an empty editor over a key nothing can store.
 *
 * `null` rather than `undefined` for "not declared", because that is a real
 * state a consumer acts on — a server older than this build — and not a value
 * that happens to be missing.
 */
export function definitionOf(
  registry: SettingsRegistryMetadata | undefined,
  key: string,
): SettingDefinitionMetadata | null {
  for (const group of registry?.groups ?? []) {
    for (const subgroup of group.subgroups) {
      const found = subgroup.settings.find((setting) => setting.key === key);

      if (found !== undefined) {
        return found;
      }
    }
  }

  return null;
}
